import Can from '../Can';
import MonitoredDocumentCompare from '../MonitoredDocument/MonitoredDocumentCompare/MonitoredDocumentCompare.container';
import PropTypes from 'prop-types';
import React from 'react';

// COMPONENT
export const MonitoredDocumentComparePage = ({ match, location }) => (
    <div className="p-3">
        <Can I="update" a="Document">
            <MonitoredDocumentCompare
                documentId={match.params.docId}
                oldVersionId={match.params.versionIds.split(',')[0]}
                newVersionId={match.params.versionIds.split(',')[1]}
                backLink={
                    location.state && location.state.backLink ? location.state.backLink : null
                }
            />
        </Can>
    </div>
);

MonitoredDocumentComparePage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            docId: PropTypes.string,
            versionIds: PropTypes.string,
        }),
    }),
    location: PropTypes.shape({
        state: PropTypes.shape({
            backLink: PropTypes.string,
        }),
    }),
};
